(function($) {
  $(document).ready(function() {
    const body = $('body');

    if (body.hasClass('template-collection')) {
      if ($('.template-collection #shopify-section-template--25916272116021__section_text_zRUPY3 .text__content').length > 0) {
        $('.template-collection #shopify-section-template--25916272116021__section_text_zRUPY3 .text__button').show();
      } else {
        $('.template-collection #shopify-section-template--25916272116021__section_text_zRUPY3 .text__button').hide();
      }

      if ($('.template-collection #shopify-section-template--25916272116021__section_text_zRUPY3 .text__button').length > 0) {
        $('.template-collection #shopify-section-template--25916272116021__section_text_zRUPY3 .text__content').toggleClass('hide');

        $('.template-collection #shopify-section-template--25916272116021__section_text_zRUPY3 .text__button').click(function(e) {
          e.preventDefault();

          const me = $(this);

          $('.template-collection #shopify-section-template--25916272116021__section_text_zRUPY3 .text__content').toggleClass('hide');

          if ($.trim(me.text()) == 'Read More') {
            me.html('<a href="javascript:void(0);" class="btn btn--solid btn--medium btn--black btn--advanced btn--advanced-width-height btn--top"><hover-button></hover-button>Read Less</a>');
          } else {
            me.html('<a href="javascript:void(0);" class="btn btn--solid btn--medium btn--black btn--advanced btn--advanced-width-height btn--top"><hover-button></hover-button>Read More</a>');
          }
        });
      }
    }

    if (body.hasClass('template-product')) {
      body.on('click', 'a[title="Size chart full"]', function(e) {
        e.preventDefault();
        
        setTimeout(function() {
          $('body .product__popup__link').trigger('click');
        }, 600);
      });
    }

    document.addEventListener('cart:updated', (e) => {
      const count = e.detail?.cart?.item_count ?? 0;
      
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = count;
      });

      document.querySelectorAll('.cart__toggle').forEach(el => {
        el.classList.toggle('cart__toggle--has-items', count > 0);
      });
    });
  });
})(jQuery);
